import script from "./DetailDataSetView.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailDataSetView.vue?vue&type=script&setup=true&lang=js"

import "./DetailDataSetView.vue?vue&type=style&index=0&id=b55a47a4&lang=css"
import "./DetailDataSetView.vue?vue&type=style&index=1&id=b55a47a4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b55a47a4"]])

export default __exports__